import { lazy } from "react"

const Layout = lazy(() =>  import("./../modules/common/layout/Layout"))
const Logout = lazy(() =>  import("./../modules/common/containers/Logout"))


export const auth = {
  path: "/auth",
  component: Layout
}

export const logout = {
  path: "/logout",
  component: Logout
}
